var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChatMuteOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_22331_35161)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.447 0.143998C12.1896 0.0218692 11.9025 -0.0237373 11.6199 0.0126056C11.3373 0.0489484 11.0711 0.16571 10.853 0.348998L4.314 3.849H1.5C1.10252 3.849 0.721293 4.00676 0.440046 4.28763C0.158799 4.5685 0.000529971 4.94952 0 5.347L0 11.655C0.00158715 12.0518 0.160323 12.4318 0.441456 12.7118C0.722588 12.9918 1.10321 13.149 1.5 13.149H4.313L10.852 16.649C11.0711 16.8305 11.3372 16.946 11.6194 16.9819C11.9016 17.0179 12.1882 16.9728 12.4458 16.8521C12.7034 16.7313 12.9213 16.5398 13.0741 16.2999C13.227 16.0599 13.3084 15.7815 13.309 15.497V1.497C13.3106 1.21248 13.2301 0.933534 13.0772 0.693572C12.9243 0.45361 12.7055 0.262802 12.447 0.143998ZM3.995 12.159H1.5C1.36739 12.159 1.24021 12.1063 1.14645 12.0126C1.05268 11.9188 1 11.7916 1 11.659V5.347C1 5.21439 1.05268 5.08721 1.14645 4.99344C1.24021 4.89968 1.36739 4.847 1.5 4.847H4V12.158L3.995 12.159ZM12.311 15.504C12.3106 15.5987 12.2833 15.6914 12.2323 15.7713C12.1813 15.8511 12.1086 15.9148 12.0228 15.9549C11.937 15.995 11.8415 16.01 11.7476 15.9979C11.6536 15.9859 11.565 15.9474 11.492 15.887L4.992 12.418V4.584L11.492 1.115C11.565 1.05455 11.6536 1.01608 11.7476 1.00406C11.8415 0.992033 11.937 1.00696 12.0228 1.04709C12.1086 1.08722 12.1813 1.15092 12.2323 1.23075C12.2833 1.31057 12.3106 1.40326 12.311 1.498V15.504Z",
    fill: "#0158E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.917 5.78839C16.7261 6.48813 17.2499 7.46016 17.3889 8.52081C17.2169 9.67442 16.7044 10.7502 15.917 11.6107",
    stroke: "#0158E6",
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.3496 4.06738C18.3496 4.06738 20.6907 6.09902 20.6907 8.41602C20.6907 10.733 18.3496 13.3311 18.3496 13.3311",
    stroke: "#0158E6",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_22331_35161"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.191,
    height: 16.994,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatMuteOff);
export default __webpack_public_path__ + "static/media/ChatMuteOff.63ab0536cb707cb50aee8f8237938327.svg";
export { ForwardRef as ReactComponent };